export default __webpack_public_path__ + "static/media/esim_color.34748477.svg";